import clsx from 'clsx';
import React from 'react';

export const CartBody = ({
  children,
  isOpen,
}: {
  children: React.ReactNode;
  isOpen: boolean;
}) => {
  return (
    <div
      className={clsx(
        'relative flex w-full flex-1 flex-col justify-between gap-8 overflow-hidden transition-opacity duration-500 xs:w-[352px]',
        isOpen ? 'opacity-100' : 'pointer-events-none opacity-0',
      )}
    >
      {children}
    </div>
  );
};

export default CartBody;
